import { render, staticRenderFns } from "./softCard.vue?vue&type=template&id=edfb1cc2&scoped=true&"
import script from "./softCard.vue?vue&type=script&lang=js&"
export * from "./softCard.vue?vue&type=script&lang=js&"
import style0 from "./softCard.vue?vue&type=style&index=0&id=edfb1cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfb1cc2",
  null
  
)

export default component.exports